import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  "enable-background": "new 0 0 24 24",
  "xml:space": "preserve"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20,0H4C1.791,0,0,1.791,0,4v16c0,2.209,1.791,4,4,4h16c2.209,0,4-1.791,4-4V4C24,1.791,22.209,0,20,0z\n    M6.323,11.677c-0.098-0.098-0.098-0.256,0-0.354L7.646,10L6.323,8.677c-0.098-0.098-0.098-0.256,0-0.354s0.256-0.098,0.354,0\n    L8,9.646l1.323-1.323c0.098-0.098,0.256-0.098,0.354,0s0.098,0.256,0,0.354L8.354,10l1.323,1.323c0.098,0.098,0.098,0.256,0,0.354\n    s-0.256,0.098-0.354,0L8,10.354l-1.323,1.323C6.579,11.774,6.421,11.774,6.323,11.677z M15.7,17.6H8.3c-0.166,0-0.3-0.134-0.3-0.3\n    C8,17.135,8.134,17,8.3,17h7.4c0.165,0,0.3,0.135,0.3,0.3C16,17.466,15.865,17.6,15.7,17.6z M17.677,11.323\n    c0.098,0.098,0.098,0.256,0,0.354s-0.256,0.098-0.354,0L16,10.354l-1.323,1.323c-0.098,0.098-0.256,0.098-0.354,0\n    s-0.098-0.256,0-0.354L15.646,10l-1.323-1.323c-0.098-0.098-0.098-0.256,0-0.354s0.256-0.098,0.354,0L16,9.646l1.323-1.323\n    c0.098-0.098,0.256-0.098,0.354,0s0.098,0.256,0,0.354L16.354,10L17.677,11.323z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}